export default "__VITE_PUBLIC_ASSET__380ec780__"